import { getActiveDepositsAmount, getDepositReturnStateText } from 'utils/deposits'
import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import { ReactComponent as Arrow } from 'assets/arrowDown.svg'
import useTranslation from 'hooks/useTranslation'
import { useParams } from 'react-router-dom'
import { displayPrice } from 'utils/string'
import { useReduxSelector } from 'store'
import { toLongDate } from 'utils/date'
import React from 'react'

const DepositsSection: React.FC = () => {
  const { id } = useParams<warehouse.PageParams>()
  const { deposits, depositsSummary } = useReduxSelector(state => selectWarehouse(state, id))
  const { t, lang } = useTranslation('warehouse')

  if (!deposits || deposits.length === 0) return null

  const activeAmount = getActiveDepositsAmount(deposits, depositsSummary)

  return (
    <div>
      <div className='list__header group'>
        <div className='element__title'>{t('deposits')}</div>
      </div>
      <div className='list__element --big'>
        <div className='element__desc'>
          {deposits.map(deposit => {
            const { id, name, amount, amountFormatted, scope, placeName, paidDate, document: depositDocument } = deposit
            const openDocument = depositDocument?.url
              ? () => {
                window.open(depositDocument.url, '_blank')
              }
              : undefined
            return (
              <div
                key={id}
                className='group'>
                <div className='element__invoice'>
                  <div><b>{name} - {amountFormatted || displayPrice(amount)}</b></div>
                  <div>{getDepositReturnStateText(deposit, t, lang)}</div>
                  {scope === 'place' && placeName && <div>{t('depositForPlace')} {placeName}</div>}
                  {paidDate && <div>{t('depositPaidDate')}: {toLongDate(paidDate, lang, true)}</div>}
                  {openDocument && <div
                    className='--action'
                    onClick={openDocument}>
                    {t(`depositDocument.${depositDocument?.type}`)}{depositDocument?.number ? ` ${depositDocument.number}` : ''}
                  </div>}
                </div>
                {openDocument && <Arrow onClick={openDocument} />}
              </div>
            )
          })}
        </div>

        {activeAmount > 0 && <div className='element__title'>
          {t('depositsActive')}: <b>{displayPrice(activeAmount)}</b>
        </div>}
      </div>
    </div>
  )
}

export default DepositsSection
